import React, { useState, useEffect } from "react";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import DataTable from "../../../components/Content/DataTable";

// Date & Time
// import Datetime from "react-datetime";
import moment from "moment";

// Utils
import { getAlert } from "../../../../utils/SamuiUtils";

// Components Date Filter
import DateFilterTable from "../../../components/Content/DateFilterTable";

function Main({
  masterList,
  detailList,
  statusColours,
  name,
  onPageInsert,
  onRowSelected,
  onRevise,
  getReport,
  setStartDate,
  setEndDate,
  startDate,
  endDate,
  fetchRealtime,
}) {
  const [dataMasterList, setDataMasterList] = useState([]);
  // const [dataDetailList, setDataDetailList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(12);
  const [, setCountWaitApprove] = useState(0);
  const [, setCountApprove] = useState(0);
  const [, setCountNotApprove] = useState(0);
  const [, setCountCancel] = useState(0);

  // ใช้สำหรับค้นหาเอกสาร
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredItems, setFilteredItems] = useState([]);

  // Filter by date & Sort by field
  // const [startDate, setStartDate] = useState(
  //   formatThaiDateUi(moment().startOf("month").toDate())
  // );
  // const [endDate, setEndDate] = useState(formatThaiDateUi(new Date()));
  const [sortOrder, setSortOrder] = useState("");
  const [sortField, setSortField] = useState("");
  const [selectedDateType, setSelectedDateType] = useState("1");
  const [allDates, setAllDates] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masterList, detailList]);

  // Optimized: ใช้ useMemo แทน useEffect เพื่อลด re-render
  useEffect(() => {
    setCurrentPage(1);
    filterItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm, dataMasterList]);

  const initialize = async () => {
    try {
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);

        // นับข้อมูลสถานะ
        let statusCounts = {
          รออนุมัติ: 0,
          อนุมัติ: 0,
          ไม่อนุมัติ: 0,
          ยกเลิก: 0,
        };

        // Optimized: ใช้ reduce แทน forEach (เร็วกว่า)
        statusCounts = masterList.reduce((acc, data) => {
          if (data.DocStatus_Name) {
            acc[data.DocStatus_Name] = (acc[data.DocStatus_Name] || 0) + 1;
          }
          return acc;
        }, statusCounts);

        setCountWaitApprove(statusCounts["รออนุมัติ"]);
        setCountApprove(statusCounts["อนุมัติ"]);
        setCountNotApprove(statusCounts["ไม่อนุมัติ"]);
        setCountCancel(statusCounts["ยกเลิก"]);
        setCurrentPage(1); // รีเซ็ตหน้าเมื่อมีข้อมูลใหม่
      }

      // if (detailList && detailList.length > 0) {
      //   setDataDetailList(detailList);
      // }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const filterItems = () => {
    if (searchTerm === "") {
      setFilteredItems(dataMasterList);
    } else {
      const lowercasedSearchTerm = searchTerm.toLowerCase();
      const filtered = dataMasterList.filter((item) =>
        Object.values(item).some(
          (value) =>
            typeof value === "string" &&
            value.toLowerCase().includes(lowercasedSearchTerm)
        )
      );
      setFilteredItems(filtered);
    }
  };

  //ค้นหาวันที่และเลขเอกสาร
  const handleSearch = async () => {
    setIsLoading(true);
    try {
      // เรียก fetchRealtime ครั้งเดียว ไม่ต้องกรองที่ client
      await fetchRealtime(false, allDates);
      // ข้อมูลจาก server จะมาที่ masterList แล้วจะ set ให้ dataMasterList ผ่าน useEffect
    } finally {
      setIsLoading(false);
    }
  };

  // Clear search and date filters
  const handleClear = () => {
    setSearchTerm("");
    setStartDate(moment().startOf("month").add(543, "year").format("YYYY-MM-DD"));
    setEndDate(moment().add(543, "year").format("YYYY-MM-DD"));
    setSelectedDateType("1");
    setAllDates(false);
    setFilteredItems(dataMasterList);
    setSortField("");
    setSortOrder("desc ");
  };

  // Sort เรียงลำดับ asc to desc
  const handleSort = () => {
    if (!sortField) return;
    // การเรียงจะขึ้นอยู่กับค่าของ newSortOrder
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newSortOrder);

    const sortedItems = [...filteredItems].sort((a, b) => {
      // ถ้า newSortOrder เป็น 'asc' จะเรียงจากน้อยไปมาก
      if (newSortOrder === "asc") {
        return a[sortField].localeCompare(b[sortField]);
      } else {
        // ถ้าเป็น 'desc' จะเรียงจากมากไปน้อย
        return b[sortField].localeCompare(a[sortField]);
      }
    });
    setFilteredItems(sortedItems);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredItems.slice(indexOfFirstItem, indexOfLastItem);

  return (
    <>
      <div className="page-header d-flex justify-content-between align-items-center mb-0">
        <Breadcrumbs
          page={name}
          items={[
            { name: "ขายสินค้า", url: "/quotation" },
            { name: name, url: "/quotation" },
          ]}
        />
      </div>
      <div
        className="row hidden-scrollbar"
        style={{ maxHeight: "80vh", overflowY: "auto", overflowX: "visible" }}
      >
        {/* <div className="col-1">
                    <center>
                        <b>สถานะเอกสาร</b>
                    </center>
                    <br />
                    {statusColours.map((statusObj, index) => {
                        const { DocSetStaus_Name, DocSetColour } = statusObj;
                        let count;

                        switch (DocSetStaus_Name) {
                            case 'รออนุมัติ':
                                count = countWaitApprove;
                                break;
                            case 'อนุมัติ':
                                count = countApprove;
                                break;
                            case 'ไม่อนุมัติ':
                                count = countNotApprove;
                                break;
                            case 'ยกเลิก':
                                count = countCancel;
                                break;
                            default:
                                count = 0;
                        }

                        return (
                            <div key={index} className="col-12 mb-3">
                                <div className="card text-center" style={{ backgroundColor: DocSetColour }}>
                                    <div className="card-body d-flex flex-column align-items-center text-white">
                                        <div className="row">
                                            <div className="col-12">
                                                <b style={{ fontSize: '20px', textAlign: 'center' }}>{count}</b>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                <b style={{ fontSize: '16px', textAlign: 'center' }}>{DocSetStaus_Name}</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div> */}
        <div className="col-12">
          <div
            className="p-3 rounded-3 my-2 shadow-lg"
            style={{ backgroundColor: "#ffff", position: "relative", zIndex: 1 }}
          >
            <div className="row  mb-2">
              <div className="col-3">
                <div className="navbar-form nav-search">
                  <div className="input-group">
                    <input
                      type="text"
                      placeholder="ค้นหาเอกสาร..."
                      className="form-control"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <span className="input-group-text">
                      <i className="fas fa-search"></i>
                    </span>
                  </div>
                </div>
              </div>
              
              <div className="col-7 d-flex align-items-center" style={{ gap: '12px' }}>
                <DateFilterTable
                  startDate={startDate}
                  endDate={endDate}
                  setStartDate={setStartDate}
                  setEndDate={setEndDate}
                  selectedDateType={selectedDateType}
                  setSelectedDateType={setSelectedDateType}
                  handleSearch={handleSearch}
                  allDates={allDates}
                  setAllDates={setAllDates}
                />
              </div>
              <div className="col-2 d-flex justify-content-end">
                <button
                  onClick={onPageInsert}
                  className="btn btn-warning text-white ms-2"
                  type="button"
                >
                  สร้าง{name} <i className="fa fa-plus"></i>
                </button>
              </div>
            </div>
            <div
              className="p-1 px-3 rounded-3 shadow-sm"
              style={{ backgroundColor: "#f5f7fd" }}
            >
              <div className="row mb-2">
                <small
                  className="d-block p-1 fw-bold"
                  style={{
                    borderLeft: "5px solid #EF6C00",
                    borderRadius: "3px",
                  }}
                >
                  เรียงลำดับตาม
                </small>

                <div className="col-1 d-flex justify-content-between">
                  <div className="radio-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={sortField === "Doc_No"}
                      onChange={() => setSortField("Doc_No")}
                    />
                    <label className="text-black">เลขที่เอกสาร</label>
                  </div>
                </div>
                <div className="col-1 d-flex justify-content-between">
                  <div className="radio-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={sortField === "Doc_Date"}
                      onChange={() => setSortField("Doc_Date")}
                    />
                    <label className="text-black">วันที่เอกสาร</label>
                  </div>
                </div>
                <div className="col-1 d-flex justify-content-between">
                  <div className="radio-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      checked={sortField === "Doc_DueDate"}
                      onChange={() => setSortField("Doc_DueDate")}
                    />
                    <label className="text-black">Due Date</label>
                  </div>
                </div>
                <div className="col-1 d-flex justify-content-between">
                  <button
                    className="btn btn-outline-secondary"
                    onClick={handleSort}
                    style={{
                      cursor: "pointer",
                      color: "black",
                      backgroundColor: "transparent",
                    }}
                  >
                    <i
                      className={`fas fa-arrow-${
                        sortOrder === "asc" ? "up" : "down"
                      }`}
                    ></i>{" "}
                    Sort
                  </button>
                </div>
                <div className="col-8 d-flex justify-content-end">
                  <button
                    onClick={handleClear}
                    className="btn btn-danger text-white"
                    type="button"
                    style={{ padding: " 0.9rem" }}
                  >
                    Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
          {isLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-[#EF6C00]" role="status" style={{ width: '3rem', height: '3rem' }}>
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-3 text-muted">กำลังโหลดข้อมูล...</p>
            </div>
          ) : (
            <DataTable
              currentItems={currentItems}
              onRowSelected={onRowSelected}
              onRevise={onRevise}
              currentPage={currentPage}
              handlePageChange={handlePageChange}
              dataMasterList={filteredItems}
              itemsPerPage={itemsPerPage}
              fieldMappings={{
                no: "Doc_No",
                rev: "Doc_Rev",
                typeName: "DocType_Name",
                statusName: "DocStatus_Name",
                statusColor: "DocStatus_Colour",
                date: "Doc_Date",
                arCode: "AR_Code",
                arName: "AR_Name",
                dueDate: "Doc_DueDate",
                netTotal: "NetTotal",
              createdBy: "Created_By_Name",
              updatedBy: "Update_By_Name",
            }}
            getReport={(docNo) => getReport("qt", docNo)}
          />
          )}
        </div>
      </div>
    </>
  );
}

export default Main;
